import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const DocusignIntegration = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const iframeRef = useRef(null); // Ref for the iframe
  const { redirectUrl } = location.state || {};

  useEffect(() => {
    if (!redirectUrl) {
      console.error("Error: Document link not found.");
      return;
    }

    // Listen for postMessage events from DocuSign
    const handlePostMessage = (event) => {
      if (event.data?.envelopeId) {
        // Navigate to Thank You page after signing is completed
        navigate("/docusignthankyou", {
          state: { envelopeId: event.data.envelopeId },
        });
      }
    };

    window.addEventListener("message", handlePostMessage);

    return () => {
      window.removeEventListener("message", handlePostMessage);
    };
  }, [navigate, redirectUrl]);

  return (
    <div className="winpay-iframe-wrapper">
      <iframe
        ref={iframeRef}
        src={redirectUrl}
        title="Docusign Document Viewer"
        className="docusign-iframe-wrapper"
      />
    </div>
  );
};

export default DocusignIntegration;
